<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <stock-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import StockCrud from "./StockCrud";
    export default {
        name: "Stock",
        components: {StockCrud}
    }
</script>

<style scoped>

</style>

